import { Item } from './types'
import { useRef } from 'react'
import { VideoTexture } from 'three'

const VideoTileMaterial: React.FC<{ item: Item; index: number }> = ({ item, index }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null)

  const video = document.createElement('video')
  video.src = item.videoSrc
  video.loop = true
  video.muted = true
  video.playsInline = true
  video.autoplay = true
  videoRef.current = video
  video.play()

  if (!videoRef.current) return null
  return <meshStandardMaterial map={new VideoTexture(videoRef.current)} attach={`material-${index}`} />
}

export default VideoTileMaterial
